// 测试加载
export function testLoaded(): void {
  console.log("loaded successfully!");
}

// 常量集合
export * from "@/constants";

// 字符串
export * from "@/string";
// 数字
export * from "@/number";
// 数组
export * from "@/array";
// 对象
export * from "@/object";
// 函数
export * from "@/function";
// 日期
export * from "@/date/index.js";
// 数学
export * from "@/math";
// 正则
export * from "@/regexp";
// 随机数
export * from "@/random";

// 文件
export * from "@/file";
// 颜色
export * from "@/color";
// 校验
export * from "@/validate";
// 键盘
export * from "@/keycode";

// 生成id
export * from "@/id";

// 加解密算法
export * from "@/crypto";
// 脱敏
export * from "@/desensitized";
// 身份证号码
export * from "@/ID-card";
// 分页
export * from "@/pagination";

// 浏览器 Url
export * from "@/url";
// 浏览器 Cookie
export * from "@/cookie";
// 浏览器 Storage
export * from "@/storage";
// 浏览器 Dom
export * from "@/dom";
// 浏览器 Device
export * from "@/device";
// 浏览器 Clipboard
export * from "@/clipboard";
